import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";
import { cn } from "../../../lib/utils";
import { IExpenseTypeRecord } from "../../../lib/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface SelectionTypeProps {
    types: IExpenseTypeRecord[];
    type?: IExpenseTypeRecord;
    setType: (t: IExpenseTypeRecord | undefined) => void;
}
export default function SelectType({ types, type, setType }: SelectionTypeProps) {
    return (
        <Select defaultValue={types.find((t) => t.default)?.name} value={type?.name || types.find((t) => t.default)?.name} onValueChange={(t) => setType(types.find((type) => type.name === t))}>
            <SelectTrigger className="w-full]">
                <SelectValue placeholder="Category" />
            </SelectTrigger>
            <SelectContent className="max-h-56">
                {types?.map((t) => (
                    <SelectItem value={t.name}>
                        <div className="flex items-center gap-2">
                            <div className={cn(t.theme?.background, t.theme?.foreground, "flex h-8 w-8 items-center justify-center rounded-lg font-medium")}>{t.icon ? <FontAwesomeIcon icon={t.icon} size="1x" /> : t.name.charAt(0).toUpperCase() || "X"}</div>
                            {t.name}
                        </div>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
